import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Alert, Badge, Button, Container, FloatingLabel, Form, Image, Table } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { LinkContainer } from 'react-router-bootstrap';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";
import { LoginInfo } from '../App';

const DynamicDialog = (props) => {
    const location = useLocation()
    const {t,i18n} = useTranslation()
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
    const width = props.width
    const height = props.height
    const autoSizing = props.autoSizing || false

    return(
        <Container onDrop={(props.onDrop || new Function)} className='m-0 p-0' style={{overflow:"auto"}}>
            <div style={{position:"fixed",top:0,left:0,width:"100%",height:"100%",backgroundColor:"#000000",opacity:0.3,zIndex:7}} onClick={() => props.switch(false)} />
            {autoSizing ? (
                <div id="dynamic-dialog" className="wrapper p-3" style={{position:"fixed",left:"0px",top:"10px",width:"100%",height:"100%",zIndex:7,overflow:"auto",backgroundColor:"#FFFFFF",borderRadius:"10px"}}>
                    {props.content}
                </div>
            ) : (
                <div id="dynamic-dialog" className="wrapper p-3" style={{position:"fixed",left:(window.innerWidth-props.width)/2,top:(window.innerHeight-props.height)/2,width:props.width+"px",height:props.height+"px",zIndex:7,overflow:"auto",backgroundColor:"#FFFFFF",borderRadius:"10px"}}>
                    {props.content}
                </div>
            )}
    </Container>
    )
}

export default DynamicDialog;
